import {FragilityComponent} from './types';

export const SERIES = {
    project: 'Il mio progetto',
    bando: 'Intero bando',
};

export const CHARTS = {
    reachRate: {
        code: 'D1.1',
        title: 'Tasso di raggiungimento dei beneficiari',
        unit: 'attività',
        tooltip:
            "Il grafico mostra il tasso di raggiungimento dei beneficiari attesi dal vostro progetto, a confronto con lo stesso valore calcolato sull'insieme dei progetti del bando. Il valore è il rapporto tra i beneficiari effettivamente raggiunti nelle attività concluse, secondo la scheda delle attività realizzate, e i beneficiari attesi per le stesse attività, secondo la scheda delle attività previste.",
    },
    distressAverage: {
        code: 'D2.1',
        title: 'Numero medio di segnali di malessere',
        unit: 'beneficiari',
        tooltip:
            "Il grafico mostra il numero medio di segnali di malessere dei beneficiari presi in carico dal vostro progetto, a confronto con lo stesso valore calcolato sull'insieme dei progetti del bando. Il valore è ottenuto contando le manifestazioni di malessere indicate nella scheda iniziale di ciascun beneficiario.",
    },
    inServices: {
        code: 'D2.2',
        title: 'Percentuale di beneficiari già in carico a servizi psichiatrici/psicologici',
        unit: 'beneficiari',
        tooltip:
            "Il grafico mostra la percentuale di beneficiari presi in carico dal vostro progetto che, all'avvio del percorso, erano già in trattamento presso servizi psicologici o psichiatrici diversi da quelli del progetto, a confronto con lo stesso valore calcolato sull'insieme dei progetti del bando.",
    },
    fragilityIndex: {
        code: 'D2.3',
        title: 'Indice di fragilità medio',
        unit: 'beneficiari',
        tooltip:
            "Il grafico mostra l'indice di fragilità medio dei beneficiari presi in carico dal vostro progetto, a confronto con lo stesso valore calcolato sull'insieme dei progetti del bando. Per ogni beneficiario l'indice considera sei condizioni: mancata convivenza con la famiglia di origine; presenza in famiglia di altre persone con problemi psicologici o psichiatrici; frequenza non regolare delle lezioni nell'ultimo anno scolastico; esperienza di bocciatura; assenza di amici o un solo amico; diagnosi di disturbi psicologici o psichiatrici specifici. L'indice è la quota di condizioni presenti sul totale di quelle rilevate, su una scala da 0 a 100.",
    },
    profile: {
        code: 'D2.4',
        title: 'Profilo dei beneficiari',
        unit: 'beneficiari',
        tooltip:
            "Il grafico mostra il profilo dei beneficiari presi in carico dal vostro progetto, a confronto con quello dell'insieme dei progetti del bando. Per ciascuna delle sei condizioni dell'indice di fragilità, il grafico indica la percentuale di beneficiari che la presentano.",
    },
    newServices: {
        code: 'D2.5',
        title: 'Percentuale di beneficiari presi in carico da servizi durante il progetto',
        unit: 'beneficiari',
        tooltip:
            "Il grafico mostra la percentuale di beneficiari del vostro progetto che, non essendo in carico a servizi psicologici o psichiatrici all'avvio del percorso, lo sono diventati durante il progetto, a confronto con lo stesso valore calcolato sull'insieme dei progetti del bando. La situazione attuale è rilevata dalla scheda finale, se disponibile, oppure dalla scheda di aggiornamento più recente.",
    },
    distressTrend: {
        code: 'D2.6',
        title: 'Andamento dello stato di benessere',
        unit: 'beneficiari',
        tooltip:
            "Il grafico mostra come è cambiato lo stato di benessere dei beneficiari presi in carico dal vostro progetto, a confronto con l'insieme dei progetti del bando. Per ogni beneficiario si confronta il numero di segnali di malessere della scheda iniziale con quello della scheda finale, se disponibile, oppure della scheda di aggiornamento più recente. Il beneficiario mostra un peggioramento se i segnali sono aumentati, stabilità se sono invariati, un miglioramento se sono diminuiti.",
    },
    activitiesTrend: {
        code: 'D2.7',
        title: 'Variazione della frequenza di attività extra-scolastiche',
        unit: 'beneficiari',
        tooltip:
            "Il grafico mostra come è cambiata la frequenza delle attività extra-scolastiche dei beneficiari presi in carico dal vostro progetto, a confronto con l'insieme dei progetti del bando. Per ogni beneficiario si confronta il numero di attività svolte almeno una volta a settimana nella scheda iniziale con quello della scheda finale, se disponibile, oppure della scheda di aggiornamento più recente.",
    },
    networkTrend: {
        code: 'D2.8',
        title: 'Variazione delle dimensioni della rete amicale',
        unit: 'beneficiari',
        tooltip:
            'Il grafico mostra come è cambiata la rete amicale dei beneficiari presi in carico dal vostro progetto, a confronto con l\'insieme dei progetti del bando. Per ogni beneficiario si confronta la rete amicale descritta nella scheda iniziale con quella della scheda finale, se disponibile, oppure della scheda di aggiornamento più recente. La rete è aumentata se il beneficiario è passato a una situazione con più amici (ad esempio da "un solo amico o nessuno" a "pochi amici" o "uno o più gruppi"), diminuita nel caso opposto.',
    },
};

export const PROFILE_AXES: Record<FragilityComponent, string> = {
    no_family_of_origin: 'Non vive con la famiglia di origine',
    family_psychological_problems: 'Familiari con problemi psicologici/psichiatrici',
    irregular_attendance: 'Frequenza scolastica irregolare',
    failed_school_year: 'Esperienza di bocciatura',
    few_friends: 'Assenza di amici o un solo amico',
    diagnosis: 'Diagnosi di disturbi psicologici/psichiatrici',
};

export const IMPROVEMENT_CATEGORIES = {
    worsened: 'Peggioramento',
    stable: 'Stabilità',
    improved: 'Miglioramento',
};

export const GROWTH_CATEGORIES = {
    increased: 'Aumento',
    stable: 'Stabilità',
    decreased: 'Diminuzione',
};
